import { MOBILE_VIEW_COOKIE } from '@beef/shop-common';
import { getCookie } from '@beef/utils';
import { headerSlices } from '@carnica/smart-kit';

export const convertLegacyHeader = (header) => {
  const currentRegion = header?.currentRegion;
  const userRegion = currentRegion?.userRegion;

  return {
    mainSiteUrl: (header?.mainSiteUrl || 'https://moskva.beeline.ru').replace(
      /((?:https)?\/\/.*?)(\/.*)/,
      '$1',
    ),
    chat: {
      digitalHelperRegionCode: '',
      digitarHelperScriptUrl: '',
      chatScritpUrl: '',
      chatRegionCode: '',
      digitarHelperServerUrl: '',
      chatServerUrl: '',
      chatDomain: '',
      restrictTopics: '',
      pagesForOldFeedback: [],
      marketCode: '',
    },
    banners: {
      mobileApp: {
        text: '',
        bgImage: '',
        buttonText: '',
        appUrl: '',
        ttl: 0,
        domainControl: '.beeline.ru',
      },
      top: {
        text: '',
        background: 'transparent',
        imageUrl: '',
        mobileImageUrl: '',
        url: '',
        id: '',
        domainControl: '.beeline.ru',
        ttl: 0,
      },
    },
    currentRegion: {
      isFTTB: true,
      id: userRegion?.id,
      code: userRegion?.code,
      title: userRegion?.title,
      titleTat: userRegion?.titleTat,
      titleEng: userRegion?.titleEng,
      titlePreposition: userRegion?.titlePreposition,
      titlePrepositionTat: userRegion?.titlePrepositionTat,
      titlePrepositionEng: userRegion.titlePrepositionEng,
    },
    topMenuLeft: [
      [],
      [
        {
          title: 'Частным лицам',
          href: '/customers/products/',
        },
        {
          title: 'Бизнесу',
          href: '/business/main/?b2c=header_Бизнесу',
        },
        {
          title: 'Партнёрам',
          href: '/business/partners/?b2c=header_Партнёрам',
        },
        {
          title: 'Госсектору',
          href: '/business/b2g/?b2c=header_Госсектору',
        },
        {
          title: 'Операторам',
          href: '/business/b2o/?b2c=header_Операторам',
        },
      ],
      [
        {
          title: 'Поставщикам и партнёрам',
          href: '/business/partners/',
        },
      ],
    ],
    topMenuRight: [
      {
        title: 'Простыми словами',
        href: '/yasnyi-yazyk-verh/',
      },
      {
        title: 'Офисы и покрытие',
        href: '/customers/beeline-map/',
      },
      {
        title: 'Помощь и поддержка',
        href: '/customers/pomosh/',
      },
    ],
    env: null,
    menu: null,
    favorite: null,
    compare: null,
    auth: {
      addUserUrl: '',
      profileUrl: '',
      profileLinkText: '',
      user: null,
      withMobileId: true,
      yandexMetricaEnabled: true,
      checkIsBeeline: true,
      isIdpEnabled: false,
    },
    reCaptchaPublicKey: '',
    basketApiUrl: '',
    cookieDomain: '',
    isBasketRedirectEnabled: false,
    searchResultsPageUrl: '/search/',
    isYasnyiYazykLinkEnabled: true,
    chatWidget: null,
    cookieSettings: {
      basketIdExpiration: '86400000',
    },
  };
};

export const getIsWebview = (url = '') => {
  const isWebViewInUrl = url.split('?')[1]?.includes('webview');
  const isWebViewInCookie = !!getCookie(MOBILE_VIEW_COOKIE);

  return isWebViewInUrl || isWebViewInCookie;
};

export const convertHeader2024 = (header, body): typeof headerSlices => {
  const currentRegion = header?.currentRegion;
  const userRegion = currentRegion?.userRegion;

  return {
    common: {
      currentRegion: {
        isFTTB: true,
        id: userRegion?.id as string,
        code: userRegion?.code as string,
        title: userRegion?.title as string,
        titleTat: userRegion?.titleTat as string,
        titleEng: userRegion?.titleEng as string,
        titlePreposition: userRegion?.titlePreposition as string,
        titlePrepositionTat: userRegion?.titlePrepositionTat as string,
        titlePrepositionEng: userRegion.titlePrepositionEng as string,
      },
      env: null,
      auth: {
        addUserUrl: '',
        profileUrl: '',
        profileLinkText: '',
        user: null,
        withMobileId: true,
        yandexMetricaEnabled: true,
        checkIsBeeline: true,
        isIdpEnabled: false,
      },
      additionalLinks: [],
      menu: {
        // проставляем id для открытия меню сразу в разделе "магазин"
        initialCategoryId: 0,
        initialTabId: 67,
      },
    },
    layout: {
      isWebView: getIsWebview(body?.requestUrl),
      theme: 'secondary',
    },
  };
};
